import urls from './urls';
import { axiosPut, axiosPost, getSourceId } from './common';
import { addAnalyticEvent } from '../analytics/common';
import {
  ORDER_STATUS_TYPE
} from '../components/tableData';

import { orderPreferenceRetrieveError } from '../analytics/orders';
import { getSvocId, getUserId } from '../../utils/general';
import {
  EMAIL_CONFIRMATION,
  SMS_CONFIRMATION,
  YES,
  NO
} from '../constants';

export function retrieveOrderPreferences(callback, err) {
  const request = {
    svocId: getSvocId(),
    userId: getUserId(),
  };

  const errorCallback = (error) => {
    addAnalyticEvent(orderPreferenceRetrieveError);
    err(error);
  };
  axiosPost({
    url: urls.RETRIEVE_ORDER_PREFERENCES,
    data: request,
    callback,
    err: errorCallback,
  });
}

function determinePreference(selected) {

  if (selected === 'text') {
    return [
      {
        type: SMS_CONFIRMATION,
        status: YES
      },
      {
        type: EMAIL_CONFIRMATION,
        status: NO
      }
    ];
  } if (selected === 'email') {
    return [
      {
        type: EMAIL_CONFIRMATION,
        status: YES
      },
      {
        type: SMS_CONFIRMATION,
        status: NO
      },
    ];
  } if (selected === 'both') {
    return [
      {
        type: EMAIL_CONFIRMATION,
        status: YES
      },
      {
        type: SMS_CONFIRMATION,
        status: YES
      }
    ];
  }
  return null;
}
export function updateOrderPreferences(tableData, selected, callback, err) {
  const preference = determinePreference(selected);
  const request = {
    svocId: getSvocId(),
    userId: getUserId(),
    sourceId: getSourceId(),
    preferences: preference,
  };

  const errorCallback = (error) => {
    addAnalyticEvent(orderPreferenceRetrieveError);
    err(error);
  };

  axiosPut({
    url: urls.UPDATE_ORDER_PREFERENCES,
    data: request,
    callback,
    err: errorCallback,
  });
}
